"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiRateLimitCategoryEnum = exports.ApiRateLimitCostEnum = exports.ApiRateLimitConfigEnum = exports.IApiRateLimitAlgorithm = exports.ApiRateLimitAlgorithmEnum = void 0;
var ApiRateLimitAlgorithmEnum;
(function (ApiRateLimitAlgorithmEnum) {
    ApiRateLimitAlgorithmEnum["BURST_ALLOWANCE"] = "burst_allowance";
    ApiRateLimitAlgorithmEnum["WINDOW_DURATION"] = "window_duration";
})(ApiRateLimitAlgorithmEnum || (exports.ApiRateLimitAlgorithmEnum = ApiRateLimitAlgorithmEnum = {}));
/**
 * The configuration options for the rate limit algorithm.
 */
class IApiRateLimitAlgorithm {
    /**
     * A decimal x >= 0 determining the proportion of base requests that are allowed in excess of the rate limit.
     *
     * For example an `x` of 0.1 would allow 10% of the base requests to exceed the rate limit.
     */
    [ApiRateLimitAlgorithmEnum.BURST_ALLOWANCE];
    /**
     * A number x >= 1 in seconds at which the rate limit allowance is refilled.
     *
     * For example a `windowDuration` of 1 would refill the rate limit allowance every second.
     */
    [ApiRateLimitAlgorithmEnum.WINDOW_DURATION];
}
exports.IApiRateLimitAlgorithm = IApiRateLimitAlgorithm;
/**
 * The configuration options for rate limiting.
 */
var ApiRateLimitConfigEnum;
(function (ApiRateLimitConfigEnum) {
    ApiRateLimitConfigEnum["ALGORITHM"] = "algorithm";
    ApiRateLimitConfigEnum["COST"] = "cost";
    ApiRateLimitConfigEnum["MAXIMUM"] = "maximum";
})(ApiRateLimitConfigEnum || (exports.ApiRateLimitConfigEnum = ApiRateLimitConfigEnum = {}));
var ApiRateLimitCostEnum;
(function (ApiRateLimitCostEnum) {
    ApiRateLimitCostEnum["SINGLE"] = "single";
    ApiRateLimitCostEnum["BULK"] = "bulk";
})(ApiRateLimitCostEnum || (exports.ApiRateLimitCostEnum = ApiRateLimitCostEnum = {}));
/**
 * The categories of rate limits.
 */
var ApiRateLimitCategoryEnum;
(function (ApiRateLimitCategoryEnum) {
    ApiRateLimitCategoryEnum["TRIGGER"] = "trigger";
    ApiRateLimitCategoryEnum["CONFIGURATION"] = "configuration";
    ApiRateLimitCategoryEnum["GLOBAL"] = "global";
})(ApiRateLimitCategoryEnum || (exports.ApiRateLimitCategoryEnum = ApiRateLimitCategoryEnum = {}));
//# sourceMappingURL=rate-limiting.js.map